<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="map">LIST OF MAPS</p>
<p class="list">  <span href="#/xhtml/chapter2#map1" title="Link target outside of Sample">1  Leggett and Smith vs. Wheeler and Cleburne</span></p>
<p class="list">  <span href="#/xhtml/chapter3#map2" title="Link target outside of Sample">2  General Hood’s Battle Plan</span></p>
<p class="list">  <span href="#/xhtml/chapter3#map3" title="Link target outside of Sample">3  Atlanta Battlefield</span></p>
<p class="list">  <span href="#/xhtml/chapter4#map4" title="Link target outside of Sample">4  Opening of Battle: Bate vs. Sweeny</span></p>
<p class="list">  <span href="#/xhtml/chapter5#map5" title="Link target outside of Sample">5  Walker vs. Sweeny and Fuller</span></p>
<p class="list">  <span href="#/xhtml/chapter6#map6" title="Link target outside of Sample">6  Cleburne vs. Giles Smith</span></p>
<p class="list">  <span href="#/xhtml/chapter7#map7" title="Link target outside of Sample">7  Maney vs. Giles Smith</span></p>
<p class="list">  <span href="#/xhtml/chapter7#map8" title="Link target outside of Sample">8  Smith’s Brigade Penetrates Gap</span></p>
<p class="list">  <span href="#/xhtml/chapter7#map9" title="Link target outside of Sample">9  Cleburne Attacks Bald Hill</span></p>
<p class="list"> <span href="#/xhtml/chapter8#map10" title="Link target outside of Sample">10  Diversionary Assault by Cheatham’s Corps</span></p>
<p class="list"> <span href="#/xhtml/chapter8#map11" title="Link target outside of Sample">11  Four Confederate Brigades Breach the XV Corps Line</span></p>
<p class="list"> <span href="#/xhtml/chapter9#map12" title="Link target outside of Sample">12  Logan Rallies to Restore Line</span></p>
<p class="list"> <span href="#/xhtml/chapter10#map13" title="Link target outside of Sample">13  Maney &amp; Cleburne Assault Bald Hill</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?50bbf559